import { isBefore } from 'date-fns'
import { hubRequest, hubRoutes } from '@/utilities'

export default {
  namespaced: true,
  state: () => ({
    item: null,
    brand: process.env.VUE_APP_BRAND,
    savedCartUUID: '',
    savedCartCreatedAt: '',
    savedCartUtmSource: '',
    savedCartUtmMedium: '',
    savedCartUtmCampaign: '',
    abandonedLeadSent: false,
    ppcLeadUUID: null,
    discountCode: '',
    discountCodeValid: null,
    discountAmount: 0
  }),
  actions: {
    clearSavedCart ({ state }) {
      state.savedCartUUID = ''
      state.savedCartCreatedAt = ''
      state.savedCartUtmSource = ''
      state.savedCartUtmMedium = ''
      state.savedCartUtmCampaign = ''
    },
    createLead ({ commit, state, getters, rootState }, payload) {
      const { abandonedCartFlag } = payload
      if (abandonedCartFlag) { state.abandonedLeadSent = true }
      return hubRequest(hubRoutes.CREATE_LEAD, { ...getters.baseSFPayload, ...payload })
        .then(res => {
          commit('ppcLeadUUID', res.data.id)
        })
    },
    updateLead ({ commit, state, getters, rootState }, payload) {
      return hubRequest(hubRoutes.UPDATE_LEAD, { ...getters.baseSFPayload, ...payload })
    },
    getDiscount ({ commit, state }) {
      const { discountCode: code } = state
      return hubRequest(hubRoutes.DISCOUNT_CODE, { code }, 'get')
        .then(res => {
          if (res.data.amount === 0) commit('discountCode', '')
          commit('discountCodeValid', res.data.amount > 0)
          commit('discountAmount', res.data.amount)
        })
        .catch(error => {
          commit('discountCodeValid', false)
          commit('discountAmount', 0)
          console.log('Error on call to /api/discountCode', error)
        })
    }
  },
  getters: {
    baseSFPayload (state, getters, rootState, rootGetters) {
      const {
        discountAmount,
        discountCode,
        savedCartCreatedAt,
        savedCartUtmCampaign,
        savedCartUtmMedium,
        savedCartUtmSource
      } = state
      return {
        brand: process.env.VUE_APP_BRAND,
        cart: state,
        ccType: '',
        customer: {
          ...rootState.customer,
          deliveryDateMilliseconds: rootGetters['customer/deliveryDateMilliseconds']
        },
        discountAmount,
        discountCode,
        mapping: null,
        onPoint: rootState.onPoint.savedLocationResponse,
        payment: {},
        project: rootState.project,
        savedCartCreatedAt,
        savedCartUtmCampaign,
        savedCartUtmMedium,
        savedCartUtmSource,
        sfid: state.ppcLeadUUID,
        taxAmount: getters.taxAmount,
        totalAmount: getters.totalAmount,
        UUID: state.savedCartUUID
      }
    },
    datesUnavailable (state, getters, rootState) {
      const datesUnavailable = state.item.datesUnavailable.map(date => {
        return new Date(`${date}T00:00:00`)
      })
      return [...datesUnavailable, ...rootState.dumpster.holidays]
    },
    minDeliveryDate (state, getters, rootState) {
      const deliveryDate = new Date(`${state.item.deliveryDate}T00:00:00`)
      const currentDate = new Date()
      currentDate.setHours(0, 0, 0, 0)
      const datesUnavailable = state.item.datesUnavailable.map(date => {
        return new Date(`${date}T00:00:00`)
      })

      const isDateUnavailable = () => {
        if ((isBefore(deliveryDate, currentDate))) {
          return true
        } else {
          return datesUnavailable.find(item => item.getTime() === deliveryDate.getTime())
        }
      }
      // if the selected product delivery date is less than or equal to today, add a day
      while (isDateUnavailable()) {
        deliveryDate.setDate(deliveryDate.getDate() + 1)
      }
      return deliveryDate
    },
    taxAmount (state, getters, rootState) {
      if (!state.item || !rootState.customer?.serviceAddress) return 0
      const { discountAmount, item } = state
      const { state: usState } = rootState.customer?.serviceAddress
      // MN and WA require discounts be applied before taxes are calculated
      // if (!['MN', 'WA'].includes(usState) || discountAmount <= 0) return item.taxAmount
      if (!['MN', 'WA'].includes(usState) || discountAmount <= 0) {
        return (Number(item.price) * (item.taxRate / 100)).toFixed(2)
      }

      return ((Number(item.price) - discountAmount) * (item.taxRate / 100)).toFixed(2)
    },
    totalAmount (state, getters, rootState) {
      if (!state.item || !rootState.customer?.serviceAddress) return 0
      const { discountAmount, item } = state
      const { state: usState } = rootState.customer?.serviceAddress
      // if (!['MN', 'WA'].includes(usState)) return (Number(item.price) + item.taxAmount - discountAmount).toFixed(2)
      if (!['MN', 'WA'].includes(usState)) return (Number(item.price) + Number(getters.taxAmount) - discountAmount).toFixed(2)
      return (Number(item.price) + Number(getters.taxAmount) - discountAmount).toFixed(2)
    }
  },
  mutations: {
    item (state, val) {
      state.item = val
    },
    discountCode (state, val) {
      state.discountCode = val.toUpperCase() // Codes are stored in postgres in ALLCAPS, this allows for case-insensitivity
    },
    discountCodeValid (state, val) {
      state.discountCodeValid = val
    },
    discountAmount (state, val) {
      state.discountAmount = val
    },
    ppcLeadUUID (state, val) {
      state.ppcLeadUUID = val
    },
    abandonedLeadSent (state, val) {
      state.abandonedLeadSent = val
    },
    savedCartUUID (state, val) {
      state.savedCartUUID = val
    },
    savedCartCreatedAt (state, val) {
      state.savedCartCreatedAt = val
    },
    savedCartUtmSource (state, val) {
      state.savedCartUtmSource = val
    },
    savedCartUtmMedium (state, val) {
      state.savedCartUtmMedium = val
    },
    savedCartUtmCampaign (state, val) {
      state.savedCartUtmCampaign = val
    }
  }
}
